// extracted by mini-css-extract-plugin
module.exports = {"link":"FileStorageButton_link__Hf80F","active":"FileStorageButton_active__2SwUM"};